<div mat-dialog-title>
    <span>{{data['title'] | truncate: 60}}</span>
    <fui-button (clickEvent)="close()"
                [iconSize]="16"
                [title]="appService.language_dictionary.system_close"
                icon="close"
                type="button-icon"
                borderRadius="circle"
                color="neutral"
                height="slim">
    </fui-button>
</div>
<mat-dialog-content class="tree-select-container">
    <mat-card fxLayout="column" class="flex flex-col h-full">
        <div class="h-full">
            <ng-container
                treeComponent
                #treeComponentSelectDialog="treeComponent"
                (validateTree$)="validateTreeResult($event)"
                (eventAdd)="data.data.eventAdd.next($event)"
                (selectItem)="data.data.isMultiple ? null : save()"
                [config]="{
                    id: 'selectDialogTree',
                    isMultiple: data.data.isMultiple,
                    isChildrenTree: data.data?.isChildrenTree,
                    isFolderSelect: data.data.isFolderSelect,
                    type: 'common',
                    levelOpen: this.data.data.levelOpen ?? 1,
                    listNodes: this.data.data.treeData,
                    valueData: this.data.data.value,
                    parentId: this.data.data.parentId,
                    buttonAdd: this.data.data?.buttonAdd === true,
                    useDefaultIcons: this.data.data?.useDefaultIcons === true,
                    isHideEmptyFolder: this.data.data?.isHideEmptyFolder === true,
                    filterType: 'filter'
                }">
            </ng-container>
        </div>
    </mat-card>
</mat-dialog-content>

<mat-dialog-actions>
    <fui-button
        [disabled]="invalid"
        label="{{appService.language_dictionary.system_save}}"
        color="primary"
        height="mini"
        icon="content-save"
        (clickEvent)="save()">
    </fui-button>
    <fui-button
        label="{{appService.language_dictionary.system_cancel}}"
        color="light"
        height="mini"
        icon="close"
        (clickEvent)="close()">
    </fui-button>
</mat-dialog-actions>
